import { createSlice } from '@reduxjs/toolkit';

import {
  createAdmin,
  getAdmins,
  getSchoolAdmins,
  finishImportAdmins,
} from './actions';

const initialState = {
  data: [] as any[],
  currentPage: 1,
  perPage: 10,
  totalPages: null as any,
};

const adminsSlice = createSlice({
  name: 'admins',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getAdmins.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(getSchoolAdmins.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(createAdmin.fulfilled, (state: any, action: any) => {
      const existingAdmin = state.data.some(
        (admin: any) => admin.id === action.payload.id,
      );

      return {
        ...state,
        data: existingAdmin
          ? state.data.map((admin: any) => {
              if (admin.id === action.payload.id) {
                return action.payload;
              }

              return admin;
            })
          : [...state.data, action.payload],
      };
    });

    builder.addCase(finishImportAdmins.fulfilled, (state: any, action: any) => {
      state.data.push(...action.payload);
    });
  },
});

export default adminsSlice.reducer;
